import { CmpMemberLifecycleStatusEnum } from "../../../../graphql/types";
import {
  getUtcCalendarDateEndUtcMilli,
  getUtcCalendarDateStartUtcMilli,
} from "../../../common/dashboard/formatters";

type FilterableManageMember = {
  lifecycleStatus: CmpMemberLifecycleStatusEnum;
  /** IF11 MB8: the derived member status where the status model is on. */
  statusKey?: string;
  searchText: string;
  renewalDateUtcMilli?: number | null;
};

export const filterManageMembers = <Member extends FilterableManageMember>({
  members,
  search,
  statuses,
  renewalDateFrom,
  renewalDateTo,
}: {
  members: readonly Member[];
  search: string;
  statuses: readonly string[];
  renewalDateFrom: string;
  renewalDateTo: string;
}): Member[] => {
  const query = search.trim().toLocaleLowerCase("en-US");
  const from = renewalDateFrom
    ? getUtcCalendarDateStartUtcMilli(renewalDateFrom)
    : null;
  const to = renewalDateTo
    ? getUtcCalendarDateEndUtcMilli(renewalDateTo)
    : null;
  return members.filter(
    (member) =>
      (statuses.length === 0 || statuses.includes(member.statusKey ?? member.lifecycleStatus)) &&
      (!query ||
        member.searchText.toLocaleLowerCase("en-US").includes(query)) &&
      (from === null ||
        (member.renewalDateUtcMilli != null &&
          member.renewalDateUtcMilli >= from)) &&
      (to === null ||
        (member.renewalDateUtcMilli != null &&
          member.renewalDateUtcMilli <= to)),
  );
};
